import { IconProps } from './IconProps';

export const UHLogo = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="32px"
      height="24px"
      viewBox="0 0 32 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Logo / 53</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="header-/-Default"
          transform="translate(-120.000000, -24.000000)"
          fill={props.fill ?? '#000'}
        >
          <g
            id="header-/-scrolled"
            transform="translate(120.000000, 20.000000)"
          >
            <g id="Logo-/-53">
              <path
                d="M28.5836299,4.22641509 L28.5836299,13.3454483 L23.474,13.3454151 L32,21.0242679 L25.8058042,27.7735849 L15.9998561,18.9433764 L6.19419577,27.7735849 L0,21.0242679 L8.526,13.3454151 L3.40498221,13.3454483 L3.40498221,4.22641509 L28.5836299,4.22641509 Z"
                id="Combined-Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

